export default __webpack_public_path__ + "static/media/d.2706722d.png";